module.exports = __webpack_public_path__ + "static/cf-bold-italic-ext-6fb6a2d634f0dd0a9f61e841fa4c972f.eot";